tinymce.addI18n('ro', {
  Redo: 'Refacere',
  Undo: 'Anulare',
  Cut: 'Decupare',
  Copy: 'Copiere',
  Paste: 'Lipire',
  'Select all': 'Selecteaz\u0103 tot',
  'New document': 'Document nou',
  Ok: 'Ok',
  Cancel: 'Revocare',
  'Visual aids': 'Ajutoare vizuale',
  Bold: 'Aldin',
  Italic: 'Cursiv',
  Underline: 'Subliniere',
  Strikethrough: 'T\u0103iere',
  Superscript: 'Exponent',
  Subscript: 'Indice',
  'Clear formatting': '\u00cendep\u0103rtare formatare',
  'Align left': 'Aliniere st\u00e2nga',
  'Align center': 'Aliniere centru',
  'Align right': 'Aliniere dreapta',
  Justify: 'Aliniere st\u00e2nga-dreapta',
  'Bullet list': 'List\u0103 marcatori',
  'Numbered list': 'List\u0103 numerotat\u0103',
  'Decrease indent': 'Mic\u0219orare indent',
  'Increase indent': 'M\u0103rire indent',
  Close: '\u00cenchidere',
  Formats: 'Formate',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": 'Browser-ul dumneavoastr\u0103 nu are acces direct la clipboard. V\u0103 rug\u0103m s\u0103 folosi\u021bi \u00een schimb scurt\u0103turile de tastatur\u0103 Ctrl+X/C/V.',
  Headers: 'Antete',
  'Header 1': 'Antet 1',
  'Header 2': 'Antet 2',
  'Header 3': 'Antet 3',
  'Header 4': 'Antet 4',
  'Header 5': 'Antet 5',
  'Header 6': 'Antet 6',
  Headings: 'Rubrici',
  'Heading 1': 'Titlu 1',
  'Heading 2': 'Titlu 2',
  'Heading 3': 'Titlu 3',
  'Heading 4': 'Titlu 4',
  'Heading 5': 'Titlu 5',
  'Heading 6': 'Titlu 6',
  Preformatted: 'Preformatat',
  Div: 'Div',
  Pre: 'Pre',
  Code: 'Cod',
  Paragraph: 'Paragraf',
  Blockquote: 'Blockquote',
  Inline: '\u00cen linie',
  Blocks: 'Blocuri',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': 'Functia "lipe\u015fte" este acum \u00een modul text simplu. Continutul va fi acum inserat ca text simplu p\u00e2n\u0103 c\u00e2nd aceast\u0103 op\u021biune va fi dezactivat.',
  Fonts: 'Fonturi',
  'Font Sizes': 'Dimensiuni font',
  Class: 'Clas\u0103',
  'Browse for an image': 'C\u0103uta\u021bi o imagine',
  OR: 'OR',
  'Drop an image here': 'Glisa\u021bi o imagine aici',
  Upload: '\u00cenc\u0103rcare',
  Block: 'Sec\u021biune',
  Align: 'Aliniere',
  Default: 'Implicit',
  Circle: 'Cerc',
  Disc: 'Disc',
  Square: 'P\u0103trat',
  'Lower Alpha': 'Minuscule Alfanumerice',
  'Lower Greek': 'Minuscule Grecesti',
  'Lower Roman': 'Minuscule Romane',
  'Upper Alpha': 'Majuscule Alfanumerice',
  'Upper Roman': 'Majuscule Romane',
  'Anchor...': 'Ancor\u0103\u2026',
  Name: 'Nume',
  Id: 'Id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.': 'Id-ul trebuie s\u0103 inceap\u0103 cu o liter\u0103, urmat\u0103 exclusiv de litere, numere, cratime, puncte, punct \u0219i virgul\u0103 sau underscore-uri.',
  'You have unsaved changes are you sure you want to navigate away?': 'Ave\u021bi modific\u0103ri nesalvate! Sunte\u0163i sigur c\u0103 dori\u0163i s\u0103 ie\u015fiti?',
  'Restore last draft': 'Restaurare la ultima salvare',
  'Special character...': 'Caracter special\u2026',
  'Source code': 'Codul surs\u0103',
  'Insert/Edit code sample': 'Inserare/Editare mostr\u0103 cod',
  Language: 'Limba',
  'Code sample...': 'Mostr\u0103 cod\u2026',
  'Color Picker': 'Selector culori',
  R: 'R',
  G: 'G',
  B: 'B',
  'Left to right': 'St\u00e2nga la dreapta',
  'Right to left': 'Dreapta la st\u00e2nga',
  'Emoticons...': 'Emoticoane\u2026',
  'Metadata and Document Properties': 'Meta date \u0219i Propriet\u0103\u021bi Document',
  Title: 'Titlu',
  Keywords: 'Cuvinte cheie',
  Description: 'Descriere',
  Robots: 'Robo\u021bi',
  Author: 'Autor',
  Encoding: 'Codare',
  Fullscreen: 'Pe tot ecranul',
  Action: 'Ac\u0163iune',
  Shortcut: 'Comand\u0103 rapid\u0103',
  Help: 'Ajutor',
  Address: 'Adres\u0103',
  'Focus to menubar': 'Centrare pe bara de meniuri',
  'Focus to toolbar': 'Centrare pe bara de unelte',
  'Focus to element path': 'Centrare pe calea elementului',
  'Focus to contextual toolbar': 'Centrare pe bara de unelte contextual\u0103',
  'Insert link (if link plugin activated)': 'Inserare link (dac\u0103 modulul de link-uri este activat)',
  'Save (if save plugin activated)': 'Salvare (dac\u0103 modulul de salvare este activat)',
  'Find (if searchreplace plugin activated)': 'C\u0103utare (dac\u0103 modulul de c\u0103utare \u0219i \u00eenlocuire este activat)',
  'Plugins installed ({0}):': 'Module instalate ({0}):',
  'Premium plugins:': 'Module premium:',
  'Learn more...': 'Afla\u021bi mai multe\u2026',
  'You are using {0}': 'Folosi\u021bi {0}',
  Plugins: 'Inserturi',
  'Handy Shortcuts': 'Comenzi rapide accesibile',
  'Horizontal line': 'Linie orizontal\u0103',
  'Insert/edit image': 'Inserare/editarea imaginilor',
  'Image description': 'Descrierea imaginii',
  Source: 'Surs\u0103',
  Dimensions: 'Dimensiuni',
  'Constrain proportions': 'Constr\u00e2nge propor\u021biile',
  General: 'General',
  Advanced: 'Avansat',
  Style: 'Stil',
  'Vertical space': 'Spa\u021biul vertical',
  'Horizontal space': 'Spa\u021biul orizontal',
  Border: 'Bordur\u0103',
  'Insert image': 'Inserare imagine',
  'Image...': 'Imagine\u2026',
  'Image list': 'List\u0103 de imagini',
  'Rotate counterclockwise': 'Rotire \u00een sensul antiorar',
  'Rotate clockwise': 'Rotire \u00een sensul orar',
  'Flip vertically': 'R\u0103sturn\u0103 vertical',
  'Flip horizontally': 'R\u0103sturn\u0103 orizontal',
  'Edit image': 'Editare imagine',
  'Image options': 'Op\u021biuni imagine',
  'Zoom in': 'M\u0103rire',
  'Zoom out': 'Mic\u015forare',
  Crop: 'Decupare',
  Resize: 'Redimensionare',
  Orientation: 'Orientare',
  Brightness: 'Str\u0103lucire',
  Sharpen: 'Accentuare',
  Contrast: 'Contrast',
  'Color levels': 'Niveluri de culoare',
  Gamma: 'Gamma',
  Invert: 'Invers\u0103',
  Apply: 'Salveaz\u0103',
  Back: '\u00cenapoi',
  'Insert date/time': 'Insereaz\u0103 data/ora',
  'Date/time': 'Data/ora',
  'Insert/Edit Link': 'Inserare/Editare link',
  'Insert/edit link': 'Inserare/editare link',
  'Text to display': 'Text de afi\u0219at',
  Url: 'Url',
  'Open link in...': 'Deschide link \u00een\u2026',
  'Current window': 'Fereastra curent\u0103',
  None: 'Nici unul',
  'New window': 'Fereastr\u0103 nou\u0103',
  'Remove link': '\u0218terge link-ul',
  Anchors: 'Ancor\u0103',
  'Link...': 'Link\u2026',
  'Paste or type a link': 'Introduce\u021bi un link',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': 'URL-ul introdus pare s\u0103 fie o adres\u0103 de e-mail. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul mailto: ?',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?': 'URL-ul introdus pare s\u0103 fie o adres\u0103 web. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul http:// ?',
  'Link list': 'List\u0103 linkuri',
  'Insert video': 'Inserare video',
  'Insert/edit video': 'Inserare/editare video',
  'Insert/edit media': 'Inserare/editare media',
  'Alternative source': 'Surs\u0103 alternativ\u0103',
  'Alternative source URL': 'URL surs\u0103 alternativ\u0103',
  'Media poster (Image URL)': 'Poster media (URL imagine)',
  'Paste your embed code below:': 'Insera\u021bi codul:',
  Embed: 'Embed',
  'Media...': 'Media\u2026',
  'Nonbreaking space': 'Spa\u021biu neseparator',
  'Page break': '\u00centrerupere de pagin\u0103',
  'Paste as text': 'Lipe\u015fte ca text',
  Preview: 'Previzualizare',
  'Print...': 'Tip\u0103rire\u2026',
  Save: 'Salveaz\u0103',
  Find: 'Caut\u0103',
  'Replace with': '\u00cenlocuie\u015fte cu',
  Replace: '\u00cenlocuie\u015fte',
  'Replace all': '\u00cenlocuie\u015fte toate',
  Previous: 'Anterior',
  Next: 'Precedent',
  'Find and replace...': 'C\u0103utare \u0219i \u00eenlocuire\u2026',
  'Could not find the specified string.': 'Nu am putut g\u0103si \u0219irul specificat.',
  'Match case': 'Distinge majuscule/minuscule',
  'Find whole words only': 'G\u0103se\u0219te doar cuvintele \u00eentregi',
  'Spell check': 'Verificare ortografic\u0103',
  Ignore: 'Ignor\u0103',
  'Ignore all': 'Ignor\u0103 toate',
  Finish: 'Finalizeaz\u0103',
  'Add to Dictionary': 'Adaug\u0103 \u00een Dic\u021bionar',
  'Insert table': 'Insereaz\u0103 tabel\u0103',
  'Table properties': 'Propriet\u0103\u021bi tabel\u0103',
  'Delete table': '\u0218terge tabel\u0103',
  Cell: 'Celul\u0103',
  Row: 'Linie',
  Column: 'Coloan\u0103',
  'Cell properties': 'Propriet\u0103\u021bi celul\u0103',
  'Merge cells': '\u00cembinarea celulelor',
  'Split cell': '\u00cemp\u0103r\u021birea celulelor',
  'Insert row before': 'Insereaz\u0103 \u00eenainte de linie',
  'Insert row after': 'Insereaz\u0103 dup\u0103 linie',
  'Delete row': '\u0218terge linia',
  'Row properties': 'Propriet\u0103\u021bi linie',
  'Cut row': 'Taie linie',
  'Copy row': 'Copiaz\u0103 linie',
  'Paste row before': 'Lipe\u015fte \u00eenainte de linie',
  'Paste row after': 'Lipe\u015fte linie dup\u0103',
  'Insert column before': 'Insereaza \u00eenainte de coloan\u0103',
  'Insert column after': 'Insereaza dup\u0103 coloan\u0103',
  'Delete column': '\u0218terge coloana',
  'Cut column': 'Taie coloan\u0103',
  'Copy column': 'Copiaz\u0103 coloan\u0103',
  'Paste column before': 'Lipe\u0219te coloana \u00eenainte',
  'Paste column after': 'Lipe\u0219te coloana dup\u0103',
  Cols: 'Coloane',
  Rows: 'Linii',
  Width: 'L\u0103\u0163ime',
  Height: '\u00cen\u0103l\u0163ime',
  'Cell spacing': 'Spa\u021biere celule',
  'Cell padding': 'Spa\u021biere',
  'Show caption': 'Afi\u0219are captur\u0103',
  Left: 'St\u00e2nga',
  Center: 'Centru',
  Right: 'Dreapta',
  'Cell type': 'Tip celul\u0103',
  Scope: 'Domeniu',
  Alignment: 'Aliniament',
  'H Align': 'Aliniere H',
  'V Align': 'Aliniere V',
  Top: 'Sus',
  Middle: 'Mijloc',
  Bottom: 'Jos',
  'Header cell': 'Antet celul\u0103',
  'Row group': 'Grup de linii',
  'Column group': 'Grup de coloane',
  'Row type': 'Tip de linie',
  Header: 'Antet',
  Body: 'Corp',
  Footer: 'Subsol',
  'Border color': 'Culoare bordur\u0103',
  'Insert template...': 'Inserare \u0219ablon\u2026',
  Templates: '\u015eabloane',
  Template: '\u0218ablon',
  'Text color': 'Culoare text',
  'Background color': 'Culoare fundal',
  'Custom...': 'Personalizat...',
  'Custom color': 'Culoare personalizat\u0103',
  'No color': 'F\u0103r\u0103 culoare',
  'Remove color': 'Eliminare culoare',
  'Table of Contents': 'Cuprins',
  'Show blocks': 'Afi\u0219are blocuri',
  'Show invisible characters': 'Afi\u0219are caractere invizibile',
  'Word count': 'Num\u0103r\u0103toare cuvinte',
  Count: 'Num\u0103r\u0103toare',
  Document: 'Document',
  Selection: 'Selec\u021bie',
  Words: 'Cuvinte',
  'Words: {0}': 'Cuvinte: {0}',
  '{0} words': '{0} cuvinte',
  File: 'Fil\u0103',
  Edit: 'Editeaz\u0103',
  Insert: 'Insereaz\u0103',
  View: 'Vezi',
  Format: 'Formateaz\u0103',
  Table: 'Tabel\u0103',
  Tools: 'Unelte',
  'Powered by {0}': 'Sus\u021binut de {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': 'Zon\u0103 cu Rich Text. Apas\u0103 ALT-F9 pentru meniu. Apas\u0103 ALT-F10 pentru bara de unelte. Apas\u0103 ALT-0 pentru ajutor',
  'Image title': 'Titlu imagine',
  'Border width': 'Grosime chenar',
  'Border style': 'Stil chenar',
  Error: 'Eroare',
  Warn: 'Aten\u021bionare',
  Valid: 'Valid',
  'To open the popup, press Shift+Enter': 'Pentru a deschide fereastra popup, ap\u0103sa\u021bi Shift+Enter',
  'Rich Text Area. Press ALT-0 for help.': 'Zon\u0103 Text Formatat. Ap\u0103sa\u021bi ALT-0 pentru ajutor.',
  'System Font': 'Font Sistem',
  'Failed to upload image: {0}': 'Nu s-a putut \u00eenc\u0103rca imaginea: {0}',
  'Failed to load plugin: {0} from url {1}': 'Nu s-a putut \u00eenc\u0103rca modulul: {0} de la URL-ul {1}',
  'Failed to load plugin url: {0}': 'Nu s-a putut \u00eenc\u0103rca URL-ul modulului: {0}',
  'Failed to initialize plugin: {0}': 'Nu s-a putut ini\u021bializa modulul: {0}',
  example: 'exemplu',
  Search: 'C\u0103utare',
  All: 'Tot',
  Currency: 'Moned\u0103',
  Text: 'Text',
  Quotations: 'Ghilimele',
  Mathematical: 'Simboluri matematice',
  'Extended Latin': 'Simboluri alfabet latin extins',
  Symbols: 'Simboluri',
  Arrows: 'S\u0103ge\u021bi',
  'User Defined': 'Definite de utilizator',
  'dollar sign': 'simbol dolar',
  'currency sign': 'simbol moned\u0103',
  'euro-currency sign': 'simbol euro',
  'colon sign': 'dou\u0103 puncte',
  'cruzeiro sign': 'simbol cruzeiro',
  'french franc sign': 'simbol franc francez',
  'lira sign': 'simbol lir\u0103',
  'mill sign': 'simbol mill',
  'naira sign': 'simbol naira',
  'peseta sign': 'simbol peset\u0103',
  'rupee sign': 'simbol rupie',
  'won sign': 'simbol won',
  'new sheqel sign': 'simbol shekel nou',
  'dong sign': 'simbol dong',
  'kip sign': 'simbol kip',
  'tugrik sign': 'simbol tugrik',
  'drachma sign': 'simbol drahm\u0103',
  'german penny symbol': 'simbol peni german',
  'peso sign': 'simbol peso',
  'guarani sign': 'simbol guarani',
  'austral sign': 'simbol austral',
  'hryvnia sign': 'simbol grivn\u0103',
  'cedi sign': 'simbol cedi',
  'livre tournois sign': 'simbol livr\u0103 tournois',
  'spesmilo sign': 'simbol spesmilo',
  'tenge sign': 'simbol tenge',
  'indian rupee sign': 'simbol rupie indian\u0103',
  'turkish lira sign': 'simbol lir\u0103 turceasc\u0103',
  'nordic mark sign': 'simbol marc\u0103 nordic\u0103',
  'manat sign': 'simbol manat',
  'ruble sign': 'simbol rubl\u0103',
  'yen character': 'simbol yen',
  'yuan character': 'simbol yuan',
  'yuan character, in hong kong and taiwan': 'simbol yuan \u00een Hong Kong \u0219i Taiwan',
  'yen/yuan character variant one': 'simbol yen/yuan prima variant\u0103',
  'Loading emoticons...': 'Se \u00eencarc\u0103 emoticoanele\u2026',
  'Could not load emoticons': 'Nu s-au putut \u00eenc\u0103rca emoticoanele',
  People: 'Persoane',
  'Animals and Nature': 'Animale \u0219i natur\u0103',
  'Food and Drink': 'M\u00e2ncare \u0219i b\u0103uturi',
  Activity: 'Activit\u0103\u021bi',
  'Travel and Places': 'C\u0103l\u0103torii \u0219i loca\u021bii',
  Objects: 'Obiecte',
  Flags: 'Steaguri',
  Characters: 'Caractere',
  'Characters (no spaces)': 'Caractere (f\u0103r\u0103 spa\u021bii)',
  '{0} characters': '{0} caractere',
  'Error: Form submit field collision.': 'Eroare: Coliziune c\u00e2mpuri la trimiterea formularului.',
  'Error: No form element found.': 'Eroare: Niciun element de formular g\u0103sit.',
  Update: 'Actualizare',
  'Color swatch': 'Mostr\u0103 de culori',
  Turquoise: 'Turcoaz',
  Green: 'Verde',
  Blue: 'Albastru',
  Purple: 'Mov',
  'Navy Blue': 'Albastru marin',
  'Dark Turquoise': 'Turcoaz \u00eenchis',
  'Dark Green': 'Verde \u00eenchis',
  'Medium Blue': 'Albastru mediu',
  'Medium Purple': 'Mov mediu',
  'Midnight Blue': 'Albastru \u00eenchis',
  Yellow: 'Galben',
  Orange: 'Portocaliu',
  Red: 'Ro\u0219u',
  'Light Gray': 'Gri deschis',
  Gray: 'Gri',
  'Dark Yellow': 'Galben \u00eenchis',
  'Dark Orange': 'Portocaliu \u00eenchis',
  'Dark Red': 'Ro\u0219u \u00eenchis',
  'Medium Gray': 'Gri mediu',
  'Dark Gray': 'Gri \u00eenchis',
  'Light Green': 'Verde deschis',
  'Light Yellow': 'Galben deschis',
  'Light Red': 'Ro\u015fu deschis',
  'Light Purple': 'Violet deschis',
  'Light Blue': 'Albastru deschis',
  'Dark Purple': 'Violet \u00eenchis',
  'Dark Blue': 'Negru \u00eenchis',
  Black: 'Negru',
  White: 'Alb',
  'Switch to or from fullscreen mode': 'Comutare pe sau de la modul ecran complet',
  'Open help dialog': 'Deschide dialogul de ajutor',
  history: 'istoric',
  styles: 'stiluri',
  formatting: 'formatare',
  alignment: 'aliniere',
  indentation: 'indentare',
  'permanent pen': 'stilou permanent',
  comments: 'comentarii',
  'Format Painter': 'Descriptor de formate',
  'Insert/edit iframe': 'Inserare/editare icadru',
  Capitalization: 'Scriere cu majuscule',
  lowercase: 'litere mici',
  UPPERCASE: 'MAJUSCULE',
  'Title Case': 'Ini\u021bial\u0103 majuscul\u0103',
  'Permanent Pen Properties': 'Propriet\u0103\u021bile stiloului permanent',
  'Permanent pen properties...': 'Propriet\u0103\u021bile stiloului permanent...',
  Font: 'Font',
  Size: 'Dimensiuni',
  'More...': 'Mai multe...',
  'Spellcheck Language': 'Verificare ortografic\u0103 a limbii',
  'Select...': 'Selectare...',
  Preferences: 'Preferin\u021be',
  Yes: 'Da',
  No: 'Nu',
  'Keyboard Navigation': 'Navigare de la tastatur\u0103',
  Version: 'Versiune',
  Anchor: 'Ancor\u0103',
  'Special character': 'Caractere speciale',
  Color: 'Culoare',
  Emoticons: 'Emoticoane',
  'Document properties': 'Propriet\u0103\u021bi document',
  Image: 'Imagine',
  'Insert link': 'Inserare link',
  Link: 'Link',
  Target: '\u021aint\u0103',
  Media: 'Media',
  Poster: 'Poster',
  Print: 'Tip\u0103re\u0219te',
  'Whole words': 'Doar cuv\u00eentul \u00eentreg',
  'Find and replace': 'Caut\u0103 \u015fi \u00eenlocuie\u015fte',
  Prev: 'Anterior',
  Spellcheck: 'Verificarea ortografic\u0103',
  Caption: 'Titlu',
  'Insert template': 'Insereaz\u0103 \u0219ablon'
});